import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { SERVICES } from "@/data/content";
import { Reveal, SectionLabel } from "./Reveal";

const Services = ({ onContact }) => {
  return (
    <section
      id="services"
      data-testid="services-section"
      className="relative py-24 md:py-36 bg-[#0A1428]"
    >
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <div className="grid md:grid-cols-12 gap-8 items-end mb-16">
          <div className="md:col-span-8">
            <SectionLabel testid="services-label">What we do</SectionLabel>
            <Reveal>
              <h2 className="font-display font-bold tracking-tight text-white text-4xl md:text-5xl lg:text-6xl leading-[1.02]">
                Everything your business needs to <span className="text-[#1E6BFF]">win online.</span>
              </h2>
            </Reveal>
          </div>
          <div className="md:col-span-4">
            <Reveal delay={0.1}>
              <p className="text-gray-400 text-base leading-relaxed">
                One senior team, end to end. No hand-offs, no agencies stacked on agencies —
                just work that moves the numbers that matter.
              </p>
            </Reveal>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {SERVICES.map((s, i) => {
            const Icon = s.icon;
            const wide = i === 0;
            return (
              <Reveal key={s.title} delay={i * 0.06} className={wide ? "md:col-span-1 md:row-span-1" : ""}>
                <motion.div
                  whileHover={{ y: -8 }}
                  transition={{ duration: 0.3, ease: "easeOut" }}
                  data-testid={`service-card-${i}`}
                  className="group relative h-full rounded-2xl border border-white/10 bg-white/[0.03] p-8 overflow-hidden hover:border-[#1E6BFF]/50 hover:shadow-lg hover:shadow-blue-500/20 transition-[border-color,box-shadow] duration-300"
                >
                  <div className="absolute -right-16 -top-16 w-40 h-40 rounded-full bg-[#1E6BFF]/10 blur-2xl opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
                  <div className="relative">
                    <div className="w-14 h-14 rounded-xl bg-[#1E6BFF]/10 border border-[#1E6BFF]/20 flex items-center justify-center mb-6">
                      <Icon size={26} strokeWidth={1.5} className="text-[#1E6BFF]" />
                    </div>
                    {s.tag && (
                      <span className="absolute top-0 right-0 text-[10px] uppercase tracking-widest font-semibold text-[#1E6BFF] bg-[#1E6BFF]/10 px-2.5 py-1 rounded-full">
                        {s.tag}
                      </span>
                    )}
                    <h3 className="font-display font-semibold text-xl text-white mb-3">{s.title}</h3>
                    <p className="text-gray-400 text-sm leading-relaxed">{s.desc}</p>
                  </div>
                </motion.div>
              </Reveal>
            );
          })}
        </div>

        <Reveal delay={0.1}>
          <div className="mt-12 flex flex-col sm:flex-row items-center justify-between gap-6 rounded-2xl border border-[#1E6BFF]/30 bg-gradient-to-r from-[#1E6BFF]/10 to-transparent p-8 md:p-10">
            <p className="font-display font-semibold text-xl md:text-2xl text-white text-center sm:text-left">
              Not sure where to start? Let's map it out together — free.
            </p>
            <button
              onClick={onContact}
              data-testid="services-cta-button"
              className="group shrink-0 inline-flex items-center gap-2 rounded-full bg-[#1E6BFF] hover:bg-[#3B82F6] text-white font-semibold px-7 py-3.5 transition-colors duration-200"
            >
              Get a Free Website Plan
              <ArrowUpRight size={18} className="transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
            </button>
          </div>
        </Reveal>
      </div>
    </section>
  );
};

export default Services;
